// No imports: the product editor and the content type checklist read it without loading
// the extension registry (which composes the StoreProduct type they belong to).

/**
 * The built-in tabs a content type may leave out: its list names the ones it shows, beside
 * its extensions (Pricing and Availability are every product's). A type without a list
 * shows them all, as before the list could name them. The server knows the same ids
 * (aldoo-na/store/extensions OPTIONAL_TABS) and leaves them out of the extensions.
 */
export const OPTIONAL_BUILTIN_TABS = [
  { id: "details", label: "Details", description: "The framework's name, id and description tab (the Information tab replaces it where enabled)" },
  { id: "licensing", label: "Licensing", description: "License model, supported platforms and seats: a product that grants a license through the store's own licensing system" },
  { id: "metadata", label: "Metadata", description: "Free key/value metadata" },
]
export const OPTIONAL_BUILTIN_TAB_IDS = OPTIONAL_BUILTIN_TABS.map((tab) => tab.id)
/**
 * Whether a product shows a built-in tab: always, unless its type's list leaves out an optional one,
 * or the editing context hides it — `hiddenBuiltinTabs`, which a project's `visibilityContext` hook
 * answers (a tab only some editors may see, whatever the product).
 */
export const builtinTabVisible = (tabId, context) => {
  if (Array.isArray(context?.hiddenBuiltinTabs) && context.hiddenBuiltinTabs.includes(tabId)) return false
  if (!OPTIONAL_BUILTIN_TAB_IDS.includes(tabId)) return true
  const list = Array.isArray(context?.storeExtensions) && context.storeExtensions.length ? context.storeExtensions : null
  return !list || list.includes(tabId)
}
